import React from 'react';
import { Helmet } from 'react-helmet';

const BlogTariffWar = () => {
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: '40px',
        backgroundColor: '#ffffff',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        maxWidth: '800px',
        margin: '100px auto 20px auto',
        fontFamily: 'Arial, sans-serif',
    };

    const titleStyle = {
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '40px',
        textAlign: 'left',
        position: 'relative',
        display: 'inline-block'
    };

    const underlineStyle = {
        position: 'absolute',
        bottom: '-30px',
        left: '0',
        width: '100%',
        height: '20px',
        backgroundImage: 'url(https://res.cloudinary.com/dyrn2eg1j/image/upload/v1742880435/Financial-Underline_s5hilj.webp)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
    };

    const sectionStyle = {
        marginBottom: '20px',
    };

    const headingStyle = {
        fontSize: '24px',
        fontWeight: 'bold',
        color: '#007BFF',
        marginBottom: '10px',
        textAlign: 'left',
        borderBottom: '3px solid #007BFF',
        display: 'inline-block',
        paddingBottom: '6px'
    };

    const paragraphStyle = {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#555',
        marginBottom: '10px',
        textAlign: 'left',
    };

    const imageStyle = {
        width: '100%',
        height: '200px',
        objectFit: 'cover',
        borderRadius: '8px',
        marginBottom: '15px',
    };

    const ctaButtonStyle = {
        display: 'inline-block',
        padding: '12px 24px',
        backgroundColor: '#ff0101',
        color: '#ffffff',
        fontSize: '16px',
        fontWeight: 'bold',
        textDecoration: 'none',
        borderRadius: '5px',
        marginTop: '20px',
        transition: 'background-color 0.3s ease',
    };

    return (
        <>
            <Helmet>
                <title>U.S.-China Tariff War 2025: Learn Trading with Stock Archery’s Courses in Bihar</title>
                <meta name="description" content="Understand the U.S.-China tariff war’s market impacts with Stock Archery’s stock market courses in Bihar and Bhagalpur. Join our trading classes to master investment strategies. Enroll today!" />
                <meta name="keywords" content="trading classes near me, stock market course Bihar, trading class Bihar, trading class Bhagalpur, stock market Bhagalpur, stock market classes, Stock Archery, U.S.-China tariff war" />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="Stock Archery" />
                <meta property="og:title" content="U.S.-China Tariff War 2025: Stock Market Courses in Bihar | Stock Archery" />
                <meta property="og:description" content="Learn to navigate market volatility from the U.S.-China tariff war with Stock Archery’s trading classes in Bihar and Bhagalpur. Start your investment journey now!" />
                <meta property="og:image" content="https://res.cloudinary.com/dyrn2eg1j/image/upload/v1745045911/Flux_Dev_Epic_digital_illustration_of_a_trade_war_between_USA__1_ovpyx0.jpg" />
                <meta property="og:url" content="https://www.stockarchery.in" />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="U.S.-China Tariff War 2025: Stock Market Courses in Bihar | Stock Archery" />
                <meta name="twitter:description" content="Master trading strategies for global events like the U.S.-China tariff war with Stock Archery’s stock market courses in Bihar and Bhagalpur. Enroll now!" />
                <meta name="twitter:image" content="https://res.cloudinary.com/dyrn2eg1j/image/upload/v1745045911/Flux_Dev_Epic_digital_illustration_of_a_trade_war_between_USA__1_ovpyx0.jpg" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Course",
                        "name": "Stock Market Courses by Stock Archery",
                        "description": "Expert-led stock market courses in Bihar and Bhagalpur, teaching trading strategies to navigate global market events like the U.S.-China tariff war.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Stock Archery",
                            "sameAs": "https://www.stockarchery.in",
                            "address": {
                                "@type": "PostalAddress",
                                "addressLocality": "Bhagalpur",
                                "addressRegion": "Bihar",
                                "addressCountry": "IN"
                            }
                        },
                        "image": "https://res.cloudinary.com/dyrn2eg1j/image/upload/v1745045911/Flux_Dev_Epic_digital_illustration_of_a_trade_war_between_USA__1_ovpyx0.jpg",
                        "offers": {
                            "@type": "Offer",
                            "priceCurrency": "INR",
                            "availability": "https://schema.org/InStock"
                        }
                    })}
                </script>
            </Helmet>
            <div style={containerStyle}>
                <h1 style={titleStyle}>
                    U.S.-China Tariff War 2025: Navigate Markets with Stock Archery
                    <div style={underlineStyle}></div>
                </h1>
                <div style={sectionStyle}>
                    <h2 style={headingStyle}>Introduction</h2>
                    <p style={paragraphStyle}>
                        The U.S.-China tariff war in 2025 is shaking global markets, creating both risks and opportunities for investors. At Stock Archery, our stock market courses in Bihar and Bhagalpur equip you with the skills to navigate such volatility. Join our trading classes near you to learn how to thrive in turbulent markets.
                    </p>
                    <img src="https://res.cloudinary.com/dyrn2eg1j/image/upload/v1745045911/Flux_Dev_Epic_digital_illustration_of_a_trade_war_between_USA__1_ovpyx0.jpg" alt="U.S.-China Tariff War 2025" style={imageStyle} />
                </div>
                <div style={sectionStyle}>
                    <h2 style={headingStyle}>Tariff Escalation</h2>
                    <p style={paragraphStyle}>
                        In April 2025, U.S. tariffs on Chinese imports reached 145%, including a 20% fentanyl-related levy. China retaliated with 125% tariffs on U.S. goods and export controls on rare earth minerals, impacting tech and semiconductor industries. Our trading classes in Bihar teach you how to analyze such global events.
                    </p>
                </div>
                <div style={sectionStyle}>
                    <h2 style={headingStyle}>Economic Impacts</h2>
                    <p style={paragraphStyle}>- U.S. households face $1,300 higher costs in 2025, with low-income families hit hardest.</p>
                    <p style={paragraphStyle}>- China’s GDP growth may drop by 0.7%, mitigated by trade diversification.</p>
                    <p style={paragraphStyle}>- Global markets falter, with the Dow Jones dropping 1,000 points and inflation rising.</p>
                    <p style={paragraphStyle}>
                        Understanding these impacts is key to smart investing. Our stock market courses in Bhagalpur help you anticipate market shifts and make informed decisions.
                    </p>
                </div>
                <div style={sectionStyle}>
                    <h2 style={headingStyle}>Strategic Moves</h2>
                    <p style={paragraphStyle}>
                        The U.S. exempted electronics to ease consumer impact, while China targets U.S. agriculture in key states. Both nations leverage strengths—U.S. tariff authority and China’s rare earth dominance—to gain leverage. Learn to strategize with Stock Archery’s trading classes in Bihar.
                    </p>
                    <img src="https://res.cloudinary.com/dyrn2eg1j/image/upload/v1745045207/Flux_Dev_A_splitscene_digital_painting_showing_Wall_Street_bul_2_mu3jd0.jpg" alt="Wall Street Impact from Tariff War" style={imageStyle} />
                </div>
                <div style={sectionStyle}>
                    <h2 style={headingStyle}>Learn to Navigate Markets with Stock Archery</h2>
                    <p style={paragraphStyle}>
                        Ready to master trading in volatile markets like the U.S.-China tariff war? Join Stock Archery’s trading classes near you in Bihar and Bhagalpur. Our stock market courses cover market analysis, risk management, and trading strategies, empowering beginners and advanced traders. Enroll in our trading class in Bihar or Bhagalpur today!
                    </p>
                    <a href="https://www.stockarchery.in" style={ctaButtonStyle}>Join Our Stock Market Courses Now</a>
                </div>
            </div>
        </>
    );
};

export default BlogTariffWar;